import { FC, useState } from 'react';

import { StyledLeftPill, StyledRightPill } from './TogglePill.styles';
import { TogglePillProps } from './TogglePill.types';
import { Box } from '@base-app';

const TogglePill: FC<TogglePillProps> = ({ options, handleTogglePillChange, defaultSelectedPill }) => {
  const [selectedPill, setSelectedPill] = useState<string>(defaultSelectedPill);

  const leftOption = options[0];
  const rightOption = options[1];

  const handleClick = (id: string): void => {
    setSelectedPill(id);
    handleTogglePillChange(id);
  };

  return (
    <Box>
      <StyledLeftPill
        data-testid={`pill-${leftOption.id}`}
        role={'pill'}
        selected={leftOption.id === selectedPill}
        onClick={() => handleClick(leftOption.id)}
      >
        {leftOption.label}
      </StyledLeftPill>

      <StyledRightPill
        data-testid={`pill-${rightOption.id}`}
        role={'pill'}
        selected={rightOption.id === selectedPill}
        onClick={() => handleClick(rightOption.id)}
      >
        {rightOption.label}
      </StyledRightPill>
    </Box>
  );
};

export default TogglePill;
